import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private api: ApiService) { }

  getAllClientConfig(data: any): Observable<any> {
    return this.api.post(environment.getAllClientConfig, data);
  }

  createClientConfig(data: any): Observable<any> {    
    return this.api.post(environment.createClientConfig, data);
  }
  updateClientConfig(data: any): Observable<any> {
    return this.api.post(environment.updateClientConfig, data);
  }
  deleteClientConfig(data: any): Observable<any> {
    return this.api.post(environment.deleteClientConfig, data);
  }

  getActiveDirectoryConfigByClientId(data: any): Observable<any> {
    return this.api.post(environment.getActiveDirectoryConfigByClientId, data);
  }

    createActiveDirectoryConfig(data: any): Observable<any> {
    return this.api.post(environment.createActiveDirectoryConfig, data);
  }

    updateActiveDirectoryConfig(data: any): Observable<any> {
    return this.api.post(environment.updateActiveDirectoryConfig, data);
  }

  
  
}
